import { useEffect } from "react";
import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickLinks from "./components/CategoryQuickLinks";
import CollectionStrip from "./components/CollectionStrip";
import SectionHeading from "@/components/base/SectionHeading";
import MediaCard from "@/components/feature/MediaCard";
import {
  collectionList,
  getFeatured,
  getHotTvShows,
  getLatestMovies,
} from "@/utils/mediaData";
import { setPageMeta } from "@/utils/seo";

export default function Home() {
  useEffect(() => {
    setPageMeta(
      "91n影视大全 - 最新电影电视剧在线观看精选",
      "91n为您提供海量电影电视剧资源，包括最新上映电影、热播电视剧及经典影视作品，满足不同观众的观影需求。探索丰富影视世界，尽在91n。"
    );
  }, []);

  const featured = getFeatured();
  const latestMovies = getLatestMovies(8);
  const hotTv = getHotTvShows(8);

  return (
    <div className="w-full">
      <HeroCarousel items={featured} />

      <CategoryQuickLinks />

      <section className="w-full px-4 md:px-8 py-8 md:py-10">
        <SectionHeading
          title="最新电影"
          subtitle="精选近期上映与口碑佳作"
          icon="ri-movie-2-line"
          moreTo="/category/movie"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latestMovies.map((item) => (
            <MediaCard key={item.id} item={item} />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-8 md:py-10 bg-background-100">
        <SectionHeading
          title="热播电视剧"
          subtitle="追更不迷路，热剧同步更新"
          icon="ri-tv-2-line"
          moreTo="/category/tv"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hotTv.map((item) => (
            <MediaCard key={item.id} item={item} showUpdated />
          ))}
        </div>
      </section>

      <CollectionStrip items={collectionList} />

      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-flex items-center gap-1.5 h-7 px-3 rounded-full bg-accent-100 text-accent-700 text-xs md:text-sm font-semibold mb-4">
            <i className="ri-information-line"></i>
            关于 91n
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4">
            91n影视大全 · 你的影视发现指南
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            91n 是一个聚合电影与电视剧资源的综合影视门户。我们每日整理最新上映影片、热播剧集与经典作品，
            通过分类筛选、专题合集与智能推荐，帮助你在海量内容中快速找到想看的那一部。无论你偏爱科幻冒险、
            古装权谋，还是轻松喜剧与温暖治愈，都能在这里找到共鸣。
          </p>
          <div className="grid grid-cols-3 gap-4 mt-8 md:mt-10">
            <div className="p-4 md:p-5 rounded-lg bg-background-100 border border-background-200">
              <p className="font-heading font-black text-2xl md:text-3xl text-primary-500">12000+</p>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">影视资源</p>
            </div>
            <div className="p-4 md:p-5 rounded-lg bg-background-100 border border-background-200">
              <p className="font-heading font-black text-2xl md:text-3xl text-accent-500">500+</p>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">热播剧集</p>
            </div>
            <div className="p-4 md:p-5 rounded-lg bg-background-100 border border-background-200">
              <p className="font-heading font-black text-2xl md:text-3xl text-secondary-500">每日</p>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">持续更新</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}